import { PALETTE } from "./constants";
import { S_BAR_CHART_SECTIONAL_DETAILS } from "./signals";
import type { IStatBarChartSectional, IStatItem } from "./types";
import { SectionalBarList, type SectionalBarListProps } from "./SectionalBarList";
import { RankingCard, RankingLegend } from "./RankingCard";
import { getRankingIcon, getRankingMax } from "./rankingData";

export const HBarChartSectionalCard = ({ item, getRowAction }: { item: IStatItem; getRowAction?: SectionalBarListProps["getRowAction"] }) => {
	const icon = getRankingIcon(item);
	const data = item.data as IStatBarChartSectional[];
	const maxItems = item.maxItems;
	const colors = item.legend?.colors ?? item.colors ?? PALETTE;
	const labels = item.legend?.labels ?? item.labels ?? [];
	const hasFullReport = !!maxItems && data.length > maxItems;
	const displayData = (hasFullReport ? data.slice(0, maxItems) : data).map(row => ({ ...row, value: row.value.map(Number) }));
	return <RankingCard title={item.title} icon={icon} onFullReport={hasFullReport ? () => {
		S_BAR_CHART_SECTIONAL_DETAILS.invoke({ title: item.title, data, legend: { colors, labels }, icon, getRowAction });
	} : undefined}>
		<RankingLegend labels={labels} colors={colors} />
		<SectionalBarList data={displayData} colors={colors} labels={labels} maxTotal={getRankingMax(displayData)} longLabels={displayData.some(row => row.label.length > 10)} icon={icon} getRowAction={getRowAction} />
	</RankingCard>;
};
